// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Menu: React.FC = () => {
    return <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="1.-Homepage" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-10.000000, -72.000000)" fill="#424242">
            <g transform="translate(22.000000, 84.000000) scale(-1, 1) translate(-22.000000, -84.000000) translate(10.000000, 72.000000)">
                <path d="M0.749922545,3.02213472 L23.2481459,3.02213472 C23.6621303,3.02213472 23.998068,2.35187565 23.998068,1.52617617 C23.998068,0.700352332 23.662068,0.0302176166 23.2481459,0.0302176166 L0.749922545,0.0302176166 C0.33593813,0.0302176166 4.67534414e-07,0.700476684 4.67534414e-07,1.52617617 C4.67534414e-07,2.35187565 0.336000468,3.02213472 0.749922545,3.02213472 Z"></path>
                <path d="M23.2481459,10.4981347 L0.749922545,10.4981347 C0.33593813,10.4981347 4.67534414e-07,11.1683938 4.67534414e-07,11.9940933 C4.67534414e-07,12.8197927 0.336000468,13.4900518 0.749922545,13.4900518 L23.2481459,13.4900518 C23.6621303,13.4900518 23.998068,12.8197927 23.998068,11.9940933 C23.998068,11.1683938 23.6621303,10.4981347 23.2481459,10.4981347 Z"></path>
                <path d="M23.2481459,20.9660518 L8.24933034,20.9660518 C7.83534592,20.9660518 7.49940826,21.6363109 7.49940826,22.4620104 C7.49940826,23.2878342 7.83540826,23.9579689 8.24933034,23.9579689 L23.2481459,23.9579689 C23.6621303,23.9579689 23.998068,23.2877098 23.998068,22.4620104 C23.998068,21.6361865 23.6621303,20.9660518 23.2481459,20.9660518 Z"></path>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Menu);
